import { createFileRoute } from "@tanstack/react-router";
import { SupportPage } from "@/components/dashboard/support-page";
export const Route = createFileRoute("/support")({
 head:()=>({meta:[{title:"Support — Deuxda Admin"},{name:"description",content:"Resolve customer and seller support tickets."},{property:"og:title",content:"Support — Deuxda Admin"},{property:"og:description",content:"Resolve customer and seller support tickets."},{property:"og:type",content:"website"},{name:"twitter:card",content:"summary_large_image"}]}),
 component:()=> <SupportPage/>,
});
